import moment from 'moment';
import { SetStateAction, Dispatch } from 'react';
import { uuid } from 'uuidv4';
import {
  editPlanFn,
  Plan,
  PlanError,
  SeparatePlansFn
} from '../components/form-controls/PlansModalControll/interfaces/PlanIntrfaces';

export const planDateFormatter = (date: Date) => {
  return moment(date).utc().toISOString();
};

export const deletePlan = (planId: string, plansArr: Plan[], setPlansFn: Dispatch<SetStateAction<Plan[]>>) => {
  const plansAfterDelete = plansArr.filter((plan) => plan.id !== planId);
  setPlansFn(plansAfterDelete);
};

export const separatePlans: SeparatePlansFn = (plans, generateId = false) => {
  const result: Plan[] = [];

  for (let i = 0; i < plans.length; i++) {
    if (plans[i].code?.match(';')) {
      const newCodes =
        plans[i].code?.split(';').map((code) => ({
          code: code,
          end_dt: plans[i].end_dt,
          start_dt: plans[i].start_dt,
          id: generateId ? uuid() : plans[i].id,
          beCode: plans[i].beCode
        })) || [];

      result.push(...newCodes);
    } else {
      result.push(plans[i]);
    }
  }
  const filteredPlan: Plan[] = result.filter((plan) => plan.code);
  return filteredPlan;
};

export const checkCodeRequired = (plans: Plan[]): PlanError[] => {
  return plans.reduce((acc: PlanError[], plan: Plan) => {
    if (!plan.code) {
      acc.push({
        type: 'CODE',
        id: plan.id,
        reason: 'The code field is required'
      });
    }
    return acc;
  }, []);
};

export const checkRequired = (plans: Plan[]): PlanError[] | [] => {
  const dateRequieredErr = plans.reduce((acc: PlanError[], plan: Plan) => {
    if (!plan.start_dt) {
      acc.push({
        type: 'START',
        id: plan.id,
        reason: 'The effective date is required'
      });
    }
    return acc;
  }, []);

  const codeRequired = checkCodeRequired(plans);
  const errors = [...codeRequired, ...dateRequieredErr];
  return errors;
};

export const getDuplicatePlans = (plans: Plan[]): PlanError[] | [] => {
  const hash = Object.create(null);

  const errors = plans.reduce((dupes: PlanError[], plan: Plan) => {
    const codeError: PlanError = {
      type: 'CODE',
      id: plan.id,
      reason: 'Plan codes must be unique'
    };
    if (plan.code) {
      if (plan.code.trim().toUpperCase() in hash) {
        dupes.push(codeError);
      } else {
        hash[plan.code.trim().toUpperCase()] = plan;
      }
    }
    return dupes;
  }, []);

  return errors;
};

export const getCodeValueError = (plans: Plan[]) => {
  const re = /[^A-Za-z0-9;]+/g;
  const error = plans.reduce((acc: PlanError[], plan: Plan) => {
    if (plan.code && plan.code.match(re)) {
      acc.push({
        type: 'CODE',
        id: plan.id,
        reason: 'The code must be valid'
      });
    }
    return acc;
  }, []);
  return error;
};

export const editPlan: editPlanFn = (id, key, value, plansArr, setPlansFn) => {
  const editedPlans = plansArr.map((plan) => {
    if (plan.id === id) return { ...plan, [key]: value };
    return plan;
  });
  setPlansFn(editedPlans);
};
